import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormGroup, FormControl, Radio, RadioGroup } from 'rsuite';
import EducationPage from '../../Credential/Shared/Education/EducationPage';

function TranscriptsSection(props) {
    return (
        <>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <FormControl
                            name="isTranscripts"
                            inline
                            accepter={RadioGroup}>
                            <Radio value={true}>ABET</Radio>
                            <Radio value={false}>NON-ABET</Radio>
                        </FormControl>
                    </FormGroup>
                </Col>
            </Row>
            {props.entityId &&
                <Row>
                    <Col>
                        <EducationPage isUserEditable={props.isUserEditable} entityId={props.entityId} activeKey={props.isClosed ? "" : 'education'} />
                    </Col>
                </Row>
            }
        </>
    );
}
export default TranscriptsSection;